import { type StateType } from '../../states';
import { type BetFilterState } from '../../states/betFilter';
import { type Selector } from '../../types/selectors';

const emptyObject = {};

export const selectBetFilterState: Selector<BetFilterState> = (state: StateType) => state.betFilter ?? emptyObject;

//#region state.betFlter
export const selectBetFilterId: Selector<number | null> = (state: StateType) => selectBetFilterState(state).id;

export const selectBetFilterIsPending: Selector<boolean> = (state: StateType) =>
  selectBetFilterState(state).isPending ?? false;
//#endregion
